let itm = {
  bcg: require('./bcg_revise.png'),
  items: [
    {
      // disable: true,
      bcg: require('./rev/bcg.png'),
      cssStyle: {
        position: 'absolute',
        top: '33.5%',
        left: '12.5%',
        height: '50.5%',
        width: '14.5%',
      },
      elem: [
        {
          bcg: require('./rev/p.png'),
          cssStyle: {
            position: 'absolute',
            top: '22.5%',
            left: '0.5%',
            height: '35%',
            width: '99%',
          },
          redirect: 'page000_game2',
          type: 'game',
        },
        {
          bcg: require('./rev/r.png'),
          cssStyle: {
            position: 'absolute',
            top: '66.7%',
            left: '8.5%',
            height: '28.8%',
            width: '82.4%',
          },
          redirect: '10',
          type: 'page',
        },
        // {
        //   disable: true,
        //   bcg: require('./rev/r1_2.png'),
        //   cssStyle: {
        //     position: 'absolute',
        //     top: '70.7%',
        //     left: '64.5%',
        //     height: '24%',
        //     width: '34.55%',
        //   },
        // },
      ],
    },
    {
      disable: true,
      bcg: require('./rev/bcg2.png'),
      cssStyle: {
        position: 'absolute',
        top: '33.5%',
        left: '28%',
        height: '50.5%',
        width: '14.5%',
      },
      elem: [
        {
          bcg: require('./rev/p2.png'),
          cssStyle: {
            position: 'absolute',
            top: '22.5%',
            left: '0.5%',
            height: '35%',
            width: '99%',
          },
        },
        {
          bcg: require('./rev/r2.png'),
          cssStyle: {
            position: 'absolute',
            top: '66.7%',
            left: '8.5%',
            height: '28.8%',
            width: '82.4%',
          },
        },
        // {
        //   bcg: require('./rev/r2_2.png'),
        //   cssStyle: {
        //     position: 'absolute',
        //     top: '70.7%',
        //     left: '64.5%',
        //     height: '24%',
        //     width: '34.55%',
        //   },
        // },
      ],
    },
    {
      disable: true,
      bcg: require('./rev/bcg3.png'),
      cssStyle: {
        position: 'absolute',
        top: '33.5%',
        left: '43.5%',
        height: '50.5%',
        width: '14.5%',
      },
      elem: [
        {
          bcg: require('./rev/p3.png'),
          cssStyle: {
            position: 'absolute',
            top: '22.5%',
            left: '0.5%',
            height: '35%',
            width: '99%',
          },
        },
        {
          bcg: require('./rev/r3.png'),
          cssStyle: {
            position: 'absolute',
            top: '66.7%',
            left: '8.5%',
            height: '28.8%',
            width: '82.4%',
          },
        },
        // {
        //   bcg: require('./rev/r3_2.png'),
        //   cssStyle: {
        //     position: 'absolute',
        //     top: '70.7%',
        //     left: '64.5%',
        //     height: '24%',
        //     width: '34.55%',
        //   },
        // },
      ],
    },
    {
      disable: true,
      bcg: require('./rev/bcg4.png'),
      cssStyle: {
        position: 'absolute',
        top: '33.5%',
        left: '59%',
        height: '50.5%',
        width: '14.5%',
      },
      elem: [
        {
          bcg: require('./rev/p4.png'),
          cssStyle: {
            position: 'absolute',
            top: '22.5%',
            left: '0.5%',
            height: '35%',
            width: '99%',
          },
        },
        {
          bcg: require('./rev/r4.png'),
          cssStyle: {
            position: 'absolute',
            top: '66.7%',
            left: '8.5%',
            height: '28.8%',
            width: '82.4%',
          },
        },
        // {
        //   bcg: require('./rev/r4_2.png'),
        //   cssStyle: {
        //     position: 'absolute',
        //     top: '70.7%',
        //     left: '64.5%',
        //     height: '24%',
        //     width: '34.55%',
        //   },
        // },
      ],
    },
    {
      disable: true,
      bcg: require('./rev/bcg5.png'),
      cssStyle: {
        position: 'absolute',
        top: '33.5%',
        left: '74.5%',
        height: '50.5%',
        width: '14.5%',
      },
      elem: [
        {
          bcg: require('./rev/p5.png'),
          cssStyle: {
            position: 'absolute',
            top: '22.5%',
            left: '0.5%',
            height: '35%',
            width: '99%',
          },
        },
        {
          bcg: require('./rev/r5.png'),
          cssStyle: {
            position: 'absolute',
            top: '66.7%',
            left: '8.5%',
            height: '28.8%',
            width: '82.4%',
          },
        },
        // {
        //   bcg: require('./rev/r5_2.png'),
        //   cssStyle: {
        //     position: 'absolute',
        //     top: '70.7%',
        //     left: '64.5%',
        //     height: '24%',
        //     width: '34.55%',
        //   },
        // },
      ],
    },
  ],
};

export default itm;
